/**
 * Recipe AJAX functions
 */

/**
 * Fetch recipes (initial load or search)
 * @param {string} search - Optional search query
 * @returns {Promise<Object>} Object containing recipes and count
 */
export async function fetchRecipes(search = '') {
	const formData = new FormData();
	formData.append('action', 'wpcore_search_recipes');
	// eslint-disable-next-line no-undef
	formData.append('nonce', wpcore.nonce);
	formData.append('search', search);
	// eslint-disable-next-line no-undef
	const stageId = new URLSearchParams(window.location.search).get('stage_id') || (wpcore.pageStageId > 0 ? String(wpcore.pageStageId) : null);
	if (stageId) {
		formData.append('stage_id', stageId);
	}

	try {
		const response = await fetch(wpcore.ajaxUrl, {
			method: 'POST',
			body: formData
		});
		const data = await response.json();

		if (data.success) {
			return data.data;
		} else {
			console.error('Error fetching recipes:', data.data?.message);
			return { recipes: [], count: 0 };
		}
	} catch (error) {
		console.error('Error fetching recipes:', error);
		return { recipes: [], count: 0 };
	}
}
